import Heading from '../Typography/Heading';
import Paragraph from '../Typography/Paragraph';

interface TextAreaProps {
  errorMsg?: string | null;
  height?: string;
  id?: string;
  label?: string;
  placeholder: string;
  maxLength: number;
  passRef: React.RefObject<HTMLTextAreaElement>;
  required?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  style?: string;
  value?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  errorMsg,
  id,
  label,
  placeholder,
  maxLength,
  height = 'h-32',
  passRef,
  required = false,
  style = '',
  onChange,
  value,
}): JSX.Element => {
  return (
    <div>
      {label && (
        <label htmlFor={id}>
          <Heading level="h5" text={label} />
        </label>
      )}
      <textarea
        className={`w-full ${height} border-2 border-black rounded-theme p-4 text-base focus:outline-none focus:border-black focus:drop-shadow-themeY ${style}`}
        id={id}
        placeholder={placeholder}
        ref={passRef}
        maxLength={maxLength}
        required={required}
        onChange={onChange}
        value={value}
      />
      {errorMsg && (
        <Paragraph color="text-red" style="text-sm" text={errorMsg} />
      )}
    </div>
  );
};

export default TextArea;
